<script lang="ts">
	//Services
	import { format } from 'src/services/i18n';

	//Design system components
	import { Button } from '@Shelly/shelly-design-system';
	import { push } from 'svelte-spa-router';
</script>

<Button
	size="m"
	class="width-md-auto width-sm-full"
	icon="fa-regular fa-arrow-up-right-from-square"
	width="m"
	on:click={() => push(`/privacy-policy`)}
	>{$format('button_open_privacy', { default: 'Open Privacy Policy' })}</Button
>
